import { Spinner, Image } from 'Common';
import { HoverImageLink, Slider } from 'Component';
import { useSliderSettings } from 'hookApi/useSliderSettings';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInsuranceCompaniesRequest } from 'redux/actions';
import { getInsuranceCompanies } from 'redux/query';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import Style from './HealthCooperationSlider.style';
import { linkHandler } from 'utils/linkHandler';

export const HealthCooperationSlider = ({ headline, children, additionalEntries = [], allowLinks = true, dotsColor = 'pink' }) => {
  const dispatch = useDispatch();
  const [totalLogoCount, setTotalLogoCount] = useState(0);

  useEffect(() => {
    dispatch(getInsuranceCompaniesRequest(true));
  }, [dispatch]);

  const insuranceCompanies = useSelector(getInsuranceCompanies);

  const sliderEntries = useMemo(() => {
    return [
      ...insuranceCompanies.filter((company) => !!(company?.zppCourseOffers || []).length && !!company.cooperationLogo),
      ...additionalEntries
    ];
  }, [insuranceCompanies]);

  useEffect(() => {
    setTotalLogoCount(sliderEntries.length);
  }, [sliderEntries]);

  const settings = useSliderSettings(totalLogoCount);

  if (!sliderEntries || totalLogoCount === 0) {
    return <Spinner />;
  }

  const renderSliderEntry = (cooperation) => {
    if (!allowLinks) {
      return <Image key={cooperation.name} src={cooperation.cooperationLogo} className="logo" />;
    }
    const linkProps = {};
    if (cooperation?.slug) {
      linkProps.to = linkHandler.get('healthInsuranceCooperation', { cooperation: cooperation.slug });
    }
    return (
      <HoverImageLink
        {...linkProps}
        key={`cooperation-${cooperation.slug}`}
        image={cooperation.cooperationLogo}
        hoverImage={cooperation.cooperationLogoHover || cooperation.cooperationLogo}
        className="logo"
      />
    );
  };

  return (
    <Style className="text-center health-cooperation-slider">
      {headline}
      <div className="slider-wrapper">
        <Slider key={settings.initialSlide} settings={settings} className={`${dotsColor}-dots`}>
          {sliderEntries.map(renderSliderEntry)}
        </Slider>
        {children}
      </div>
    </Style>
  );
};
